export function anchorLinks() {
    $(".anchor-link").on("click", function (e) {
        const href = $(this).attr('href');
        const section = $(`${href}`);
        e.preventDefault();
        $("html, body").animate({scrollTop: section.offset().top}, 1000);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchorLinks.js